// extracted by mini-css-extract-plugin
export default {"camelize(phone)":"375px","camelize(tablet)":"667px","camelize(desktop)":"1024px","appWrapper":"App-module_appWrapper__d5Bhh"};